var _circle, _g, _circle2, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgLoginDropbox = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 125,
    viewBox: "0 0 230 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 167.326,
    cy: 62.6032,
    r: 61.82,
    fill: "#0061FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6775_1034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.81 36.7168L136.464 46.4789L151.81 56.241L167.162 46.4789L182.514 56.241L197.864 46.4789L182.514 36.7168L167.162 46.4789L151.812 36.7168H151.81ZM151.81 75.7652L136.464 66.0052L151.81 56.241L167.162 66.0031L151.81 75.7652ZM167.164 66.0052L182.514 56.241L197.866 66.0031L182.514 75.7652L167.162 66.0031L167.164 66.0052ZM167.164 88.7813L151.812 79.0192L167.164 69.2571L182.516 79.0192L167.164 88.7813Z",
    fill: "#F7F5F2"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6857,
    cy: 62.6032,
    r: 61.82,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1419 84.5324C54.395 84.5324 58.195 75.6467 58.1952 64.7105C58.195 53.7743 54.3947 44.8843 47.1419 44.8887C39.8891 44.8931 36.0847 53.7743 36.0845 64.7105C36.0847 75.6467 39.885 84.5324 47.1375 84.5324L47.1419 84.5324Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3947 93.3618C83.4137 93.3618 89.2868 79.6916 89.2868 62.606C89.2868 45.5159 83.4137 31.8457 73.3947 31.8457C63.3759 31.8457 57.5029 45.5159 57.5029 62.6015C57.5029 79.6916 63.376 93.3618 73.3947 93.3618Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6775_1034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.7629,
    height: 53.1357,
    fill: "white",
    transform: "translate(135.444 36.0352)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginDropbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login-dropbox.2606f1d1f474e93351888c018eaa23c9.svg";